import { CardContent, Typography } from "@material-ui/core";
import React from "react";
import { AdminUserDetailsResponse } from "../../../../../../services/user-admin/types/api/user-details-response";
import {
  CardLoading,
  CardLoadingProps,
} from "../../../components/card-loading";

interface UserLoginOptionsProps extends CardLoadingProps {
  user: AdminUserDetailsResponse;
}

export const UserLoginOptions: React.FC<UserLoginOptionsProps> = ({
  user,
  ...props
}) => {
  return (
    <CardLoading {...props}>
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Login Options
        </Typography>
        {user.loginMethod.map((account, i) => (
          <Typography key={i} variant="button">
            {account}
          </Typography>
        ))}
      </CardContent>
    </CardLoading>
  );
};
